(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_967a149"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-video-banner-auto')) {
    customElements.define('product-video-banner-auto', class extends HTMLElement {
      connectedCallback() {
        this.frameRequest = requestAnimationFrame(() => this.initialise());
      }

      initialise() {
        if (!this.isConnected || this.controller) return;
        this.video = this.querySelector('video');
        if (!this.video) return;

        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.loop = true;
        this.video.playsInline = true;
        this.video.controls = false;

        const cover = this.querySelector('.pvb-cover');
        if (cover) this.video.poster = cover.currentSrc || cover.src;

        this.video.addEventListener('playing', () => {
          if (this.motion.matches) {
            this.video.pause();
            this.removeAttribute('data-playing');
          } else {
            this.setAttribute('data-playing', '');
          }
        }, options);

        this.video.addEventListener('pause', () => {
          this.removeAttribute('data-playing');
        }, options);

        this.video.addEventListener('error', () => {
          this.removeAttribute('data-playing');
        }, options);

        this.motion.addEventListener('change', () => this.syncPlayback(), options);
        document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
        window.addEventListener('pageshow', () => this.syncPlayback(), options);
        this.syncPlayback();
      }

      syncPlayback() {
        if (!this.video || !this.isConnected) return;
        const shouldPlay = !this.motion.matches && !document.hidden;
        this.video.autoplay = shouldPlay;

        if (!shouldPlay) {
          this.video.pause();
          this.removeAttribute('data-playing');
          return;
        }

        this.video.muted = true;
        this.video.defaultMuted = true;

        if (!this.video.paused && this.video.readyState >= 3) {
          this.setAttribute('data-playing', '');
          return;
        }

        const attempt = this.video.play();
        if (attempt && typeof attempt.catch === 'function') {
          attempt.catch(() => {
            if (this.video.paused) this.removeAttribute('data-playing');
          });
        }
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frameRequest);
        if (this.controller) this.controller.abort();
        this.controller = null;
        if (this.video) {
          this.video.autoplay = false;
          this.video.pause();
        }
        this.removeAttribute('data-playing');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
